<div class="d-flex table-scrollable">
    <div class="table-scrollable__fixed">
        <div class="table-scrollable__fixed-shadow"></div>
        <table class="table-scrollable__fixed__table stage-table">
            <thead>
                <tr class="bg-light">
                    <th class="table-scrollable__table-th font-weight-normal text-center"><br />#</th>
                    <th class="table-scrollable__table-th font-weight-normal text-center">&nbsp;</th>
                    <th class="table-scrollable__table-th table-scrollable__fixed__table__text font-weight-normal">
                        <br />
                    </th>
                </tr>
            </thead>
            <tbody>
                @for (participant of participants; track $index) {
                <tr
                    class="table-scrollable__table-row"
                    [class.app-cursor]="![59, 97].includes(sportId)"
                    (click)="openStageParticipant(stage.category_id, stage.parent_id, participant.id)"
                >
                    <td class="table-scrollable__table-td table-scrollable__table-place">
                        @if (participant.position) {
                        <span
                            class="span"
                            [ngClass]="{
                                'medal-gold': participant.values['gold'],
                                'medal-silver': participant.values['silver'],
                                'medal-bronze': participant.values['bronze']
                            }"
                            >{{ participant.position }}</span
                        >
                        } @else { @if (participant.values['dnf']) {
                        <span class="span">DNF</span>
                        } @if (participant.values['dns']) {
                        <span class="span">DNS</span>
                        } @if (participant.values['dsq']) {
                        <span class="span">DSQ</span>
                        } }
                    </td>
                    <td class="table-scrollable__table-td text-center">
                        @if (participant.iso) {
                        <img
                            src="/img/flags/1x1/{{ participant.iso | lowercase }}.svg"
                            alt=""
                            class="rounded-circle mr-2"
                            height="20"
                        />
                        } @if (!participant.iso && ![59, 97].includes(sportId)) {
                        <img src="/img/default-avatar.png" alt="" class="rounded-circle mr-2" height="20" />
                        }
                    </td>
                    <td class="table-scrollable__table-td table-scrollable-team">
                        {{ participant.name_short }}
                        @if (stage.shirts && false) { @if (participant.values['climber_ranking'] == 1) {
                        <img
                            class="ml-1"
                            height="20"
                            src="{{ stage.shirts }}/climber.png"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="{{ 'web.cycling-climber' | translate }}"
                        />
                        } @if (participant.values['sprint_ranking'] == 1) {
                        <img
                            class="ml-1"
                            height="20"
                            src="{{ stage.shirts }}/sprint.png"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="{{ 'web.cycling-sprinter' | translate }}"
                        />
                        } @if (participant.values['young_rider_ranking'] == 1) {
                        <img
                            class="ml-1"
                            height="20"
                            src="{{ stage.shirts }}/young_rider.png"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="{{ 'web.cycling-young-rider' | translate }}"
                        />
                        } }
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>

    <div class="table-scrollable__data flex-grow-1" tableScroll>
        <table class="table-scrollable__data__table stage-table">
            <thead>
                <tr class="bg-light">
                    @if (stage.hasTeams) {
                    <th class="table-scrollable__table-th table-scrollable__data__table-th text-left">
                        <br />{{ 'web.team' | translate }}
                    </th>
                    } @for (childStage of stage.childStages; track $index) { @for (valueType of
                    childStage.valueTypes.competitors; track $index) { @if (!['dnf', 'dns', 'dsq'].includes(valueType))
                    {
                    <th class="table-scrollable__table-th table-scrollable__data__table-th">
                        {{ childStage?.description }}<br />
                        {{ 'stagevaluetype.' + stage.category + '_' + valueType | translate }}
                    </th>
                    } } } @for (childStage of stage.childStages; track $index) { @for (valueType of
                    childStage.valueTypes.teams; track $index) { @if (!['dnf', 'dns', 'dsq'].includes(valueType)) {
                    <th class="table-scrollable__table-th table-scrollable__data__table-th">
                        {{ childStage?.description }}<br />
                        {{ 'stagevaluetype.' + stage.category + '_' + valueType | translate }}
                    </th>
                    } } } @for (valueType of valueTypes; track $index) { @if (!['gold', 'silver',
                    'bronze'].includes(valueType)) {
                    <th class="table-scrollable__table-th table-scrollable__data__table-th">
                        <br />{{ 'stagevaluetype.' + valueType | translate }}
                    </th>
                    } }
                </tr>
            </thead>
            <tbody>
                <ng-container>
                    @for (participant of participants; track $index) {
                    <tr
                        class="table-scrollable__table-row stage-table-participant"
                        [class.app-cursor]="![59, 97].includes(sportId)"
                        (click)="openStageParticipant(stage.category_id, stage.parent_id, participant.id)"
                    >
                        @if (stage.hasTeams) {
                        <td class="table-scrollable__table-td table-scrollable__data__table-td text-left">
                            {{ participant.team_name }}
                        </td>
                        } @for (childStage of stage.childStages; track $index; let i = $index) { @for (valueType of
                        childStage?.valueTypes?.competitors ?? []; track $index) { @if (!['dnf', 'dns',
                        'dsq'].includes(valueType)) {
                        <td class="table-scrollable__table-td table-scrollable__data__table-td">
                            {{ stage?.childStages[i]?.participants[participant.id]?.values[valueType] }}
                        </td>
                        } } } @for (childStage of stage.childStages; track $index; let i = $index) { @for (valueType of
                        childStage?.valueTypes?.teams ?? []; track $index) { @if (!['dnf', 'dns',
                        'dsq'].includes(valueType)) {
                        <td class="table-scrollable__table-td table-scrollable__data__table-td">
                            {{ stage?.childStages[i]?.participants[participant.id]?.values[valueType] }}
                        </td>
                        } } } @for (valueType of valueTypes; track $index) { @if (!['gold', 'silver',
                        'bronze'].includes(valueType)) {
                        <td class="table-scrollable__table-td table-scrollable__data__table-td">
                            @if ( stageListService.translatableValues.includes(participant.values[valueType])) {
                            {{ 'web.stagevalue_' + participant.values[valueType] | lowercase | translate }}
                            } @else {
                            {{ participant.values[valueType] }}
                            } @if ( valueType === 'fastest_lap_time' && stage.fastestLaps.length && stage.fastestLaps[0]
                            === participant.values[valueType] ) {
                            <i
                                class="fas fa-stopwatch fastest-lap"
                                data-toggle="tooltip"
                                data-placement="top"
                                title="{{ 'web.fastest_lap' | translate }}"
                            ></i>
                            }
                        </td>
                        } }
                        <!--                        <ng-container *ngFor="let childStage of stage.childStages">-->
                        <!--                            <ng-container *ngFor="let value of childStage?.participants[participant.id]?.values ?? {} | keyvalue">-->
                        <!--                                <td class="table-scrollable__table-td table-scrollable__data__table-td">-->
                        <!--                                    {{ value.key }}:{{ value.value }}-->
                        <!--                                </td>-->
                        <!--                            </ng-container>-->
                        <!--                        </ng-container>-->
                    </tr>
                    }
                </ng-container>
            </tbody>
        </table>
    </div>
</div>
